__turbopack_context__.v({
  "container": "limited-access-recommendations-carousel-module-scss-module__k5JVmq__container",
  "unit": "limited-access-recommendations-carousel-module-scss-module__k5JVmq__unit",
});
